// src/app/public-home/PublicHero.tsx

import * as React from "react";

import {
  Link,
} from "react-router-dom";

import {
  LOGIN_URL,
} from "../../lib/environment";

import {
  ProductPreview,
} from "./ProductPreview";

/* -------------------------------------------------------------------------- */
/* Wordmark                                                                   */
/* -------------------------------------------------------------------------- */

function Wordmark():
React.JSX.Element {
  return (
    <Link
      to="/"
      className="public-wordmark"
      aria-label="Estatly home"
    >
      Estatly
    </Link>
  );
}

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export function PublicHero():
React.JSX.Element {
  return (
    <section className="public-hero">
      <div className="public-container public-hero-grid">
        <div className="public-hero-copy">
          <Wordmark />

          <div className="public-hero-message">
            <h1>
              The property, the work and the people in one place.
            </h1>

            <p>
              For property managers, self-managed owners and tradespeople.
            </p>
          </div>

          <div className="public-hero-actions">
            <a
              href={
                LOGIN_URL
              }
              className="public-button public-button-sign-in"
            >
              Sign in
            </a>

            <a
              href="#request-access"
              className="public-button public-button-secondary"
            >
              Request access
            </a>
          </div>
        </div>

        <div className="public-hero-media">
          <ProductPreview />
        </div>
      </div>
    </section>
  );
}